/**
 * SECTION - RESEARCH
 */

import RouteSelector from "../containers/RouteSelector";
import LocalSelector from "../containers/LocalSelector";
import { views } from "./../services/constants";

const { investigation } = views;

const ResearchRoutes = {
  routes: [
    /*{
      path: ["/uaresearch", "/investigacao"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "research"
      }
    },
    {
      path: ["/scientific-activity", "/atividade-cientifica"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "scientificActivity"
      }
    },
    {
      path: ["/research-units", "/unidades-investigacao"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "researchUnits"
      }
    },
    {
      path: ["/scientific-research", "/producao-cientifica"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "scientificResearch"
      }
    },

    
      {
        path: ["/id-projects", "/projetos-id"],
        component: RouteSelector,
        props: {
          activeView: investigation,
          document: "idProjects"
        }
      },
    */

    {
      path: ["/id-projects/:id", "/projetos-id/:id"],
      component: LocalSelector,
      props: {
        activeView: investigation,
        document: "projectDetails"
      }
    },
    {
      path: ["/id-projects", "/projetos-id"],
      component: LocalSelector,
      props: {
        activeView: investigation,
        document: "projects"
      }
    } /*,
    {
      path: ["/chairs", "/catedras"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "chairs"
      }
    },
    {
      path: ["/open-science", "/ciencia-aberta"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "openScience"
      }
    },
    {
      path: ["/funding", "/financiamento"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "funding"
      }
    },
    {
      path: ["/funding1", "/financiamento1"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "fundingOne"
      }
    },
    {
      path: ["/research-magazine", "/revista-investigacao"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "fundingReports"
      }
    },
    {
      path: ["/funding-processes", "/procedimentos-financiamento"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "fundingProcesses"
      }
    },
    {
      path: ["/doctoral-school", "/escola-doutoral"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "doctoralSchool"
      }
    },
    {
      path: ["/research-support", "/apoio-investigacao"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "researchSupport"
      }
    },
    {
      path: ["/hiring", "/recrutamento"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "hiring"
      }
    },
    {
      path: ["/mobility-fund", "/fundo-mobilidade"],
      component: RouteSelector,
      props: {
        activeView: investigation,
        document: "mobilityFund"
      }
    }*/
  ]
};

export default ResearchRoutes;
